export default __webpack_public_path__ + "bf15247234421089684499427e015b09.png";